// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3gAVJ","disabled":"FileBtn_disabled__2s5F-","warn":"FileBtn_warn__1IXEV","fade":"FileBtn_fade__pHPYw"};